const USE_CASES = [
  { value: 'work', label: 'Work' },
  { value: 'school', label: 'School' },
  { value: 'personal', label: 'Personal' },
];

export { USE_CASES };
